import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import dayjs from 'dayjs';

import Accordion from '~/components/Accordion';
import { useCurrentUser } from '~/domains/auth/queries';
import type { OAISchema } from '~/types/openapi';
import { appAlert } from '~/utils/mobileApp';

import ProductInquireDescription from './ProductInquireDescription';
import ProductInquireSummary from './ProductInquireSummary';
import { INQUIRY_TYPE } from '../constants';
import { useInfiniteProductInquiries } from '../queries';

export type ProductInquiry = OAISchema['MarketPlaceProductInquiryResponse'];

type Props = {
  offerId: number;
  onEdit?(values: ProductInquiry): void;
  onDelete?(id: number): void;
};
function ProductInquireContainer({ offerId, onEdit, onDelete }: Props) {
  const { ref, inView } = useInView();
  const { pages = [], fetchNextPage } = useInfiniteProductInquiries(offerId);

  const { user } = useCurrentUser();

  const showSecretDialog = () => {
    appAlert({
      description: '비밀글입니다.',
    });
  };

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <>
      <Accordion>
        {pages.map((inquiry) => {
          const myInquiry = user?.id === inquiry.buyerId;

          // 내가 쓴 글이 아닌 다른 사용자의 비밀글
          const isOthersSecretInquiry = !myInquiry && inquiry.isSecret;
          return (
            <Accordion.Panel
              key={inquiry.id}
              index={inquiry.id!}
              label={
                <ProductInquireSummary
                  title={inquiry.content}
                  category={INQUIRY_TYPE[inquiry.type]}
                  name={inquiry.vendorName}
                  inquireAt={dayjs(inquiry.createdAt).format('YYYY.MM.DD')}
                  secret={inquiry.isSecret}
                  hidden={isOthersSecretInquiry}
                  done={!!inquiry.answer}
                />
              }
              disabled={isOthersSecretInquiry}
              onClickDisabled={showSecretDialog}
            >
              <ProductInquireDescription
                question={inquiry.content}
                onDelete={() => onDelete?.(inquiry.id!)}
                onEdit={() => onEdit?.(inquiry)}
                hideAction={!myInquiry}
                allowEdit={!isOthersSecretInquiry && !inquiry.answer}
                answer={inquiry.answer}
              />
            </Accordion.Panel>
          );
        })}
      </Accordion>
      <div ref={ref} />
    </>
  );
}

export default ProductInquireContainer;
